import React from 'react';
import ProductCard from './ProductCard';
import EmptyState from '../common/EmptyState';
import { theme } from '../../config/theme';

const ProductGrid = ({ 
  products, 
  loading, 
  showActions = false,
  onEdit,
  onDelete,
  onClick,
  emptyMessage = 'No products found',
  emptyAction,
}) => {
  const gridStyles = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: theme.spacing.lg,
  };

  const loadingStyles = {
    padding: theme.spacing['3xl'],
    textAlign: 'center',
    color: theme.colors.text.secondary,
  };

  if (loading) {
    return <div style={loadingStyles}>Loading products...</div>;
  }

  if (!products || products.length === 0) {
    return (
      <EmptyState
        icon="📦"
        title={emptyMessage}
        description="Try adjusting your filters or search terms"
        action={emptyAction}
      />
    );
  }

  return (
    <div style={gridStyles}>
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          onClick={onClick}
          showActions={showActions}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default ProductGrid;